.modalOverlay {
  background-color: var(--color-backdrop);
  position: absolute;
  inset: 0;
  z-index: 999;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  cursor: pointer;
  overflow: hidden;
}

.modalPortal {
  position: absolute;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  overflow: hidden;
  max-height: 100%;
  //transition: max-height 200ms ease, top 200ms ease;
}

@media (max-width: 639px) {
  .modalPortal {
    padding: 0.75rem;
  }
}

.modalContainer {
  z-index: 1000;
  position: fixed;
  inset: 0;

  &[data-visible="false"] {
    visibility: hidden;
    pointer-events: none;
  }
}

dialog.modalContainer {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
}

dialog.modalContainer::backdrop {
  background-color: var(--color-backdrop);
}

@keyframes overlayShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// A dialog that was in the server HTML is already on screen when it moves into the portal after
// hydration: don't fade it in again.
.modalContainer[data-server-rendered="true"] {
  .modalOverlay,
  .modalPortal > [role="dialog"] {
    animation: none;
  }
}
